// Generated types for PDMPort
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { PortDefinitionReadAPI, PortDefinitionWriteAPI } from '../../sysml/types/portdefinition';
import { PortDefinitionReadAPISchemaObject, PortDefinitionWriteAPISchemaObject } from '../../sysml/types/portdefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PDMPortReadAPI extends PortDefinitionReadAPI {
  /** Port type: POWER, DATA, MECHANICAL, FLUID */
  port_type: string;
  /** Voltage rating */
  voltage?: number | null;
  /** Current rating */
  current?: number | null;
  /** Data transmission rate */
  data_rate?: string | null;
}

export interface PDMPortWriteAPI extends PortDefinitionWriteAPI {
  /** Port type: POWER, DATA, MECHANICAL, FLUID */
  port_type: string;
  /** Voltage rating */
  voltage?: number | null;
  /** Current rating */
  current?: number | null;
  /** Data transmission rate */
  data_rate?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PDMPortReadAPISchema: z.ZodType<PDMPortReadAPI> = PortDefinitionReadAPISchemaObject.extend({
  port_type: z.string(),
  voltage: z.number().nullable().optional(),
  current: z.number().nullable().optional(),
  data_rate: z.string().nullable().optional(),
}).passthrough();

export const PDMPortWriteAPISchema: z.ZodType<PDMPortWriteAPI> = PortDefinitionWriteAPISchemaObject.extend({
  port_type: z.string(),
  voltage: z.number().nullable().optional(),
  current: z.number().nullable().optional(),
  data_rate: z.string().nullable().optional(),
}).passthrough();
